/**
 * Wordmark / town header (design README "Wordmark / town header"): town logo + name in the
 * display serif — shown on STANDALONE resident pages.
 *
 * In the widget embed the LAUNCHER owns the modal chrome (slim town-name header + Close ✕),
 * per widget/spec.md §4 "the launcher owns the modal chrome, the iframe owns the form". So this
 * header renders NOTHING in embed mode — rendering it produced a doubled header (launcher chrome +
 * this wordmark) with two close buttons. Close in embed is the launcher's ✕/scrim/Esc, answered by
 * `useEmbedClose` (ADR-0004 postMessage handshake).
 *
 * Resident forms are a single BRANDED look pulled from the town's site — no light/dark toggle
 * (theming.md, "branded, no toggle"). The mode toggle used to live here; it's staff-console-only
 * now (StaffShell renders its own).
 */
import { useTheme } from "../theme/ThemeProvider.js";

interface Props {
  embed: boolean;
  /** Optional reassurance sub-copy under the wordmark (intake header). Standalone only. */
  subcopy?: string;
}

export function TownHeader({ embed, subcopy }: Props): JSX.Element | null {
  const { config } = useTheme();

  // Embed: the launcher's slim header IS the chrome — don't render a second one inside the iframe.
  if (embed) return null;

  return (
    <header className="td-header">
      <div className="td-header__brand">
        {config.logoUrl ? (
          <img className="td-header__logo" src={config.logoUrl} alt={`${config.townName} logo`} />
        ) : null}
        <span className="td-header__name">{config.townName}</span>
      </div>
      {subcopy ? <p className="td-header__subcopy">{subcopy}</p> : null}
    </header>
  );
}
